/**
 * Cross-module handoff of a ready-to-use Keycloak logout URL (incl.
 * id_token_hint), captured by the live app while it still has an
 * authenticated session, and read by the bootstrap-error page as a fast,
 * cookie-independent secondary attempt before it falls back to its own
 * self-contained keycloak-js re-init.
 *
 * Deliberately a module-scoped variable, NOT a window global: the stashed
 * URL embeds the idToken, and must not be readable by third-party scripts
 * sharing the page (Instana, Kameleoon). This relies on the single-bundle
 * invariant (main.ts statically imports the bootstrap-error handler chain,
 * so this module is evaluated once, shared by both the live app and the
 * error page).
 */
let stashedLogoutUrl: string | null = null;

/** Called by the live app once identity has been established with an active session. */
export function storeLogoutHandoffUrl(url: string): void {
  stashedLogoutUrl = url;
}

/** Read lazily by the bootstrap-error page, at click time. */
export function getLogoutHandoffUrl(): string | null {
  return stashedLogoutUrl;
}

/** Test-only reset. */
export function resetLogoutHandoffUrl(): void {
  stashedLogoutUrl = null;
}
